import { PText, PTextList, PTextListItem } from "@porsche-design-system/components-react"
import type { PublishingRuleViolation } from "@slfinrtl/ui-bff-routes"
import type { PropsWithChildren, JSX } from "react"
import { Tooltip } from "../../tooltip/Tooltip"

interface ViolatedPublishingRulesTooltipProps extends PropsWithChildren {
	title: string | JSX.Element
	violatedPublishingRules?: PublishingRuleViolation[]
}

export const ViolatedPublishingRulesTooltip = ({
	children,
	title,
	violatedPublishingRules,
}: ViolatedPublishingRulesTooltipProps) => {
	return (
		children && (
			<Tooltip
				appendToBody
				content={
					<>
						<PText weight="semibold">{title}</PText>
						{violatedPublishingRules?.length && (
							<PTextList>
								{violatedPublishingRules.map((rule, index) => (
									<PTextListItem key={index}>{rule.message}</PTextListItem>
								))}
							</PTextList>
						)}
					</>
				}
			>
				{children}
			</Tooltip>
		)
	)
}
